import type { Session } from "@/features/auth/api/session.api";

/**
 * Uygulama açılmadan önce parola değişmeli mi (31 Ekim 2026).
 *
 * Yönetici kişiye bir parola verdiyse («Parolayı sıfırla») ya da kurulum ilk yöneticiye üretilmiş bir
 * parola yazdıysa hesap `mustChangePassword` taşıyor. Kişi onu değiştirene kadar sunucu yalnız değiştirme
 * ekranının uçlarını açıyor (`AuthGuard`, 403 `PASSWORD_CHANGE_REQUIRED`); `AppLayout` de uygulamanın
 * yerine bu ekranı çiziyor — menü, pano, zil hiçbiri o güne kadar sorulmuyor.
 *
 * DESTEK OTURUMUNDA DEĞİL: «Kullanıcı değiştir» ile girilen pencerede ekrandaki kişi yönetici; başkasının
 * parolasını onun yerine değiştiremez, ve pencere zaten o kişinin gördüğünü görmek için açılıyor. Sunucu
 * da aynı istisnayı yapıyor.
 *
 * `tenant-choice.ts` ile aynı gerekçeyle AYRI dosyada: bileşenle aynı modülde duran düz bir işlev hızlı
 * yenilemeyi bozuyor.
 */
export function mustChangePassword(session: Session): boolean {
  return session.user.mustChangePassword === true && session.impersonation === null;
}
